<script>
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  name: 'SearchDataDischargerSiteModal',
  components: {
    CommonTableComponent
  },
  mixins: [pagination, tableSearch],
  props: ['dataSearch','errorValid'],
  data() {
    return {
      currentInputSelectData: "",
      header: this.$constant.tableHeaders.common.searchs.discharger_sites,
      busyGetData: false,
      data: [],
      visible: false,
      filters: {
        searchValue: "",
        column: "discharger_sites.discharger_site_cd",
        dir: "ASC",
        page: 1
      }
    };
  },
  methods: {
    async getData() {
      this.busyGetData = true;
      const response = await this.$http.get(apiEndpoints.popup_search_discharger_sites, {
        ...this.filters,
      });
      const { status, data } = response;
      this.busyGetData = false;
      if (status) {
        const result = data.result;
        this.data = this.$_.isEmpty(result) ? [] : result;
        // const meta = this.$_.isEmpty(result.meta) ? [] : result.meta;
        // this.setMeta(meta);
      }
    },
    updateValue: function(value) {
      this.dataSearch.discharger_site = value;
      this.$emit('dataSelected', this.dataSearch)
      this.closeModal();
    },
    openModal() {
      this.$bvModal.show("modal-select-data-workplace");
    },
    closeModal() {
      this.$bvModal.hide("modal-select-data-workplace");
    },
    performDebounceSearch () {
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    updateUrlFilters () {
      this.getData()
    },
    isInputError(input){
      if (!this.errorValid) return false;

      return !!this.errorValid[input];
    },
  },
  watch: {
    "filters.page": {
      immediate: false,
      handler() {
        this.updateUrlFilters();
      }
    },
  },
  computed: {
    headers() {
      return this.header;
    },
    inputSearch: {
      get() {
        return this.dataSearch.discharger_site;
      },
      set(newValue) {
        this.dataSearch.discharger_site = newValue;
      }
    },
  }
};
</script>
<template>
  <div class="mb-2 d-xl-flex">
    <slot name="label">
      <label :for="'workplace'" class="col-form-label text-nowrap me-2"
        >事業場略称</label
      >
    </slot>
    <div class="d-flex w-100">
      <div class="w-100 me-2">
        <input
          type="text"
          class="form-control me-2"
          id="workplace"
          v-model="inputSearch"
          :class="{
              'is-invalid': isInputError('discharger_site')
            }"
        />
        <div
          v-if="isInputError('discharger_site')"
          class="invalid-feedback"
        >
          {{ errorValid['discharger_site'][0] }}
        </div>
      </div>
      <b-button
        @click="openModal()"
        variant="outline-info"
        class="cus-h-btn"
      >
        <i class="bx bx-file-find"></i>
      </b-button>
    </div>
    <!-- modal area -->
    <b-modal
      size="xl"
      id="modal-select-data-workplace"
      centered
      title-class="font-18"
      hide-footer
      title="事業場略称一覧"
      scrollable
      @show="getData"
    >
      <b-row>
        <div>
          <b-form-input
            placeholder="フィルター..."
            v-model="filters.searchValue"
            v-on:keyup.enter="performDebounceSearch"
            type="text"
            id="name"
          ></b-form-input>
        </div>
      </b-row>
      <b-row class="mt-2">
        <b-overlay
          :show="busyGetData"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <CommonTableComponent :height-class="`table-wrapper-500`">
            <thead class="table-light">
              <tr>
                <th
                  v-for="(item, index) in headers"
                  :key="index"
                  :class="getHeaderClass(item)"
                >
                  <span v-if="item.sortable" @click="clickSort(item.value)">
                    {{ item.text }}
                    <i :class="getSortClass(item.value)"></i>
                  </span>
                  <span v-else>
                    {{ item.text }}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in data"
                :key="index"
                class="cursor-pointer"
                @click="updateValue(item.name_abbreviated)"
              >
                <td>
                  {{ item.discharger_site_cd }}
                </td>
                <td>
                  {{ item.name_abbreviated }}
                </td>
                <td>
                  {{ item.address }}
                </td>
                <td>
                  {{ item.tel }}
                </td>
                <td>
                  {{ item.discharger_site_person_in_charge }}
                </td>
                <td>
                  {{ item.user_1_name }}
                </td>
                <td>
                  {{ item.user_2_name }}
                </td>
                <td>
                  {{ item.zz_own }}
                </td>
              </tr>
              <tr v-if="!data.length && !busyGetData">
                <td :colspan="headers.length" class="text-center">
                  データなし。
                </td>
              </tr>
            </tbody>
          </CommonTableComponent>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
<style scoped>
.cus-h-btn {
  max-height: 38px;
}
</style>
